module.exports = __webpack_public_path__ + "img/IT0000145615188.128c3415.png";